<template>
  <Layout>
    <PageHeader :items="items" />
    <!--FILTER START------>

    <div class="card mt-2 mb-5">
      <div class="card-body">
        <h5>Schedule Feedback Report </h5>
      </div>
    </div>

    <div class="card" style="margin-top: -30px; ">

      <div class="card-body">
        <div class="inner mb-2 row">
          <!-- Country List-->
          <div class="col-md-4">
            <label>Country </label>
            <multiselect
              v-model="country"
              :options="countryArr"
              :show-labels="false"
              label="country"
              track-by="country"
              @input="getAllCities()"
            ></multiselect>
          </div>

          <div class="col-md-4">
            <label>Select City </label>
            <multiselect
              v-model="city"
              :options="cityArr"
              :show-labels="false"
              label="city"
              track-by="city"
              @input="getPrincipleAndCorporates()"
            ></multiselect>
          </div>
          <div v-if="login_type != 3" class="col-md-4">
            <label>Select Principle Branch </label>
            <multiselect
              v-model="principleBranchID"
              :options="principleBranches"
              :show-labels="false"
              label="principleBranchName"
              track-by="principleBranchID"
              @input="getRestaurantByPrincipleBranch"
            ></multiselect>
          </div>

        </div>
        <div class="row mt-3">
          <div class="col-md-4">
            <label class="form-label">Select Corporate Branch </label>
            <multiselect
                v-model="corpBranchID"
                :options="corpBranches"
                :show-labels="false"
                label="corpBranchName"
                track-by="corpBranchID"
                open-direction="bottom"
                @input="getRestaurantByCorporateBranch"
            ></multiselect>

          </div>
          <div class="col-md-4">
            <label class="form-label" for="form row-endTime-input"
              >Select Restaurant Branch*</label
            >
            <multiselect
              v-model="restBranchID"
              :class="{
                'is-invalid': submitted && $v.restBranchID.$error
              }"
              :options="restBranchArr"
              label="restaurantName"
              track-by="restBranchID"
              open-direction="bottom"
              @input="getRestaurantEmployees"
            ></multiselect>
          </div>
          <div class="col-md-4">
            <label class="form-label" for="form row-endTime-input"
            >Select Restaurant Employee</label
            >
            <multiselect
                v-model="rest_employees"
                :options="employees"
                label="name"
                track-by="restEmpID"
                open-direction="bottom"
                multiple></multiselect>
          </div>


          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <label class="form-label" for="form row-endTime-input"
              >Select Cloudkitch Staff</label
              >
              <multiselect
                  v-model="ck_employee"
                  :options="staffs"
                  label="name"
                  track-by="empID"
                  open-direction="bottom"
                  multiple

              ></multiselect>
            </div>
          <div class="col-md-4">
            <label>Date Range </label>
            <date-picker
              v-model="daterange"
              append-to-body
              confirm
              format="DD MMM Y"
              value-type="format"
              lang="en"
              range
            ></date-picker>
          </div>
          <div class="col-md-2">
            <button class="btn btn-themeOrange mt-4" v-on:click="applyFilter()">
              Submit
            </button>
          </div>
          <!-- Clear filter -->
          <div class="col-md-2">
            <button class="btn btn-themeBrown mt-4" v-on:click="clearFilter()">
              Clear Filter
            </button>
          </div>
          <!-- Clear filter END-->
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
         <div class="row">
                <div class="col-12">
                  <div class="row mt-4">
                    <div class="col-sm-12 col-md-4" style="margin-bottom: 15px">
                      <div class="btn-group" role="group">
                       
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Show &nbsp;&nbsp;
                          <b-form-select
                            v-model="perPage"
                            :options="pageOptions"
                            size="sm"
                            style="margin-left: 5px; margin-right: 5px"
                          ></b-form-select
                          >&nbsp;&nbsp;&nbsp; entries
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-4 row">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                      >
                        <label class="d-inline-flex align-items-center">
                          Search:
                          <b-form-input
                            v-model="filter"
                            class="form-control form-control-sm ms-2"
                            placeholder="Search..."
                            type="search"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>
                  <!-- Table -->
                  <div class="table-responsive mb-0">
                    <!-- <column-visibility :fields.sync="fields"></column-visibility> -->
                    <b-table
                      :busy="isReportTableBusy"
                      :current-page="currentPage"
                      :fields="fields"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      :items="tableData"
                      :per-page="perPage"
                      bordered
                      fixed
                      fixed-header
                      head-variant="light"
                      outlined
                      responsive="sm"
                      striped
                      @filtered="onFiltered"
                    >
                      

                      <template #table-busy>
                        <div class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      </template>
                      <template v-slot:cell(cloudkitch_staff)="data">
                        <span v-for="(staff, index) in data.item.cloudkitch_staff" :key="index" :title="staff" class="text-danger">
                          {{ staff.name }}<br>
                        </span>
                      </template>
                       <template v-slot:cell(restaurant_employees)="data">
                        <span v-for="(employee, index) in data.item.restaurant_employees" :key="index" :title="employee" class="text-yellow">
                          {{ employee.name }}<br>
                        </span>
                      </template>

                       <template v-slot:cell(excel_file_path)="data">
                        <a :href="data.item.excel_file_path" target="_blank" rel="noopener" class="text-primary">Download Excel Sheet</a>
                     
                      </template>
                                    
                      <template v-slot:cell(pdf_file_path)="data">
                        <a :href="data.item.pdf_file_path" target="_blank" rel="noopener" class="text-primary">Download PDF</a>
                      </template>
                    </b-table>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div
                        class="
                          dataTables_paginate
                          paging_simple_numbers
                          float-end
                        "
                      >
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="rows"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

        </div>
    </div>
   </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Schedule Feedback Report",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    DatePicker
  },
  data() {
    return {
      login_type:0,

      title: "Schedule Feedback Report",
      items: [
        {
          text: "View"
        },
        {
          text: "Schedule Feedback Report",
          active: true
        }
      ],

      currentPage: 1,
      totalRows: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 500, 1000, 2000, "All"],
      branches: [],
      cityArr: [],
      city: "",
      daterange: [],
      countryArr: [],
      orderData: [],
      orderDetails: [],
      country: "",
      brandArr: [],
      brandData: "",
      restBranchID: this.$storageData.profile.restBranchID,
       filter: null,
      filterOn: [],
      isReportTableBusy: false,
      replyField: "",
      feedbackIdhold: "",
      repliedTextArr: [],
      otherRatingsArr: [],
      ratingbyuser: "",
      series: [],
      repliedText: "",
      repliedBy: "",
      submitted: false,
      restaurantID: "",
      branchID: "",
      companyArr: [],
      companyID: 0,
      ratingQ: 5,
      restNAme: "",
      principleBranchID: "",
      principleBranches: [],
      corpBranchID: "",
      corpBranches: [],
      restBranchArr: [],
      rest_employees:[],
      employees:[],
      ck_employee:[],
      staffs:[],
      tableData: [],
      fields: [
        {
          key: "principle_branch",
          sortable: true
        },
        {
          key: "corporate_branch",
          sortable: true
        },

        {
          key: "restaurant_branch",
          sortable: true
        },

        {
          key: "cloudkitch_staff",
          sortable: true
        },
        {
          key: "restaurant_employees",
          sortable: true
        },
        {
          key: "date_from",
          sortable: true,
          tdClass: "align-center"
        },
        {
          key: "date_till",
          sortable: true,
          tdClass: "align-center"
        },
        {
          key: "excel_file_path",
          sortable: true,
          tdClass: "align-center"
        },
        {
          key: "pdf_file_path",
          sortable: false
        },

        {
          key: "created_at",
          sortable: true
        },
       
      ],
    };
  },
  validations: {
    replyField: {
      required
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  mounted() {
    this.login_type=this.$storageData.login_type;
this.totalRows = this.items.length;
    if ( this.$storageData.profile.empTypeID == 2 ||
        this.$storageData.profile.empTypeID == 11) {
      this.getRestaurantCountry();
    }
    else
    {
      this.getAllCountry();
    }
    this.readCloudkitchEmployees();
this.getScheduledData();
  },

  methods: {
    getScheduledData(){
this.axios.get(this.$loggedRole+"/get-scheduled-feedbacks").then(response => {
        this.tableData = response.data.data;
      
      });
    },
 onFiltered(filteredItems) {
    
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAllCountry() {
      this.countryArr = [];
      this.country = "";
      this.axios.post(this.$loggedRole+"/getAllCountry").then(response => {
        this.countryArr = response.data.data;
        if (this.$storageData.profile.empTypeID == 11) {
          this.getAllCompanies();
          this.getRestaurantBrandsByCompanyID();
        }
      });
    },
    getAllCities() {
      this.cityArr = [];
      this.city = "";
      let corporate_branch = 0;
      let corporate_id = 0;
      if (this.$storageData.profile.empTypeID == 5) {
        corporate_id = this.$storageData.profile.corporateID;
      }
      if (this.$storageData.profile.empTypeID == 6) {
        corporate_id = this.$storageData.profile.corporateID;
        corporate_branch = this.$storageData.profile.corpBranchID;
      }
      let formData = new FormData();
      formData.append("country", this.country ? this.country.country : "");
      formData.append("corporate_id", corporate_id);
      formData.append("corporate_branch", corporate_branch);
      formData.append("empTypeID", this.$storageData.profile.empTypeID);
      formData.append("empID", this.$storageData.profile.pid);
      this.axios.post(this.$loggedRole+"/v2/getAllCities", formData).then(response => {
        this.cityArr = response.data.data;
        if (this.$storageData.profile.empTypeID == 1) {

          this.getAllCompanies();
        }
        if (this.$storageData.profile.empTypeID == 11) {
          this.getAllCompanies();
          this.getRestaurantBrandsByCompanyID();
        } else {
          this.readRestaurantBranchData();
        }
      });
    },

    getRestaurantBrands() {
      this.axios
        .post(this.$loggedRole+"/getRestaurantList", {
          restID: this.$storageData.profile.restID,
          restBranchID: this.$storageData.profile.restBranchID,
          empTypeID: this.$storageData.profile.empTypeID
        })
        .then(result => {
          this.brandArr = result.data.data;
          this.brandData = this.brandArr ? this.brandArr[0] : "";
          this.readRestaurantBranchData();
        });
    },
    getRestaurantBrandsByCompanyID() {
      var companyID = this.companyID;
      if (this.$storageData.profile.empTypeID == 11) {
        companyID = this.$storageData.profile.companyID;
      }
      this.axios
        .post(this.$loggedRole+"/getRestaurantBrandsByCompanyID", { companyID: companyID })
        .then(response => {
          this.brandArr = response.data.data;
          this.readRestaurantBranchData();
        });
    },
    getRestaurantCountry() {
      this.axios
        .post(this.$loggedRole+"/getRestaurantCountry", {
          restID: this.$storageData.profile.restID,
          company_id:this.$storageData.profile.companyID
        })
        .then(response => {
          this.countryArr = response.data.data;
          this.country = this.countryArr ? this.countryArr[0] : "";
          this.getRestaurantCities();
        });
    },
    getRestaurantCities() {
      var restID = this.brandData.restID;
      if (this.$storageData.profile.empTypeID == 11) {
        restID = this.$storageData.profile.restID;
      }
      this.axios
        .post(this.$loggedRole+"/getRestaurantCities", {
          restID: restID,
          country: this.country ? this.country.country : "",
          company_id:this.$storageData.profile.companyID
        })
        .then(response => {
          this.cityArr = response.data.data;
        });
    },
    getAllCompanies() {
      this.companyArr = [];
      this.companyID = "";
      var companyID = 0;
      if (this.$storageData.profile.empTypeID == 11) {
        companyID = this.$storageData.profile.companyID;
      }
      this.axios
        .post(this.$loggedRole+"/getAllCompanies", { companyID: companyID })
        .then(response => {
          this.companyArr = response.data.data;
          if (this.$storageData.profile.empTypeID == 11) {
            this.companyID = this.companyArr ? this.companyArr[0] : "";
          }
        });
    },
    readRestaurantBranchData() {
      this.axios
        .post(this.$loggedRole+"/getRestaurantBranchByRestID", {
          restID:
            this.brandData != ""
              ? this.brandData.restID
              : this.$storageData.profile.restID,
          restBranchID: 0,
          empTypeID: this.$storageData.profile.empTypeID,
          city: this.city ? this.city.city : ""
        })
        .then(response => {
          this.branches = response.data.data;
          this.branchID = this.branches ? this.branches[0] : "";
          this.restBranchID = this.branchID ? this.branchID.restBranchID : "";
        });
    },

    applyFilter() {
      if (this.daterange.includes(null)) {
        this.daterange = [];
      }
      this.scheduleFeedbackReport()
    },

    clearFilter() {
      this.daterange = [];
      this.branches = [];
      this.brandData = "";
      this.restBranchID = "";
      this.country = "";
      this.companyID = "";
      this.brandData = "";
      this.city = "";
      this.branchID = "";

      this.principleBranches = this.corpBranches = this.rest_employees= this.employees = this.staffs= [];
      this.day = this.session = this.principleBranchID = this.corpBranchID = "";


    },



    scheduleFeedbackReport() {
      if (this.$storageData.login_type == 3 && this.corpBranchID.length <= 0) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Please select the corporate branch."
        });
        return;
      }
      if (
        this.$storageData.login_type != 3 &&
        this.principleBranchID.length <= 0 &&
        this.corpBranchID.length <= 0
      ) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Please select either principle branch or corporate branch."
        });
        return;
      }
      if(this.rest_employees.length==0) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Please select restaurant employee."
        });
      }
      if(this.ck_employee.length==0) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Please select cloudkitch staff."
        });
      }
      if (
        this.$storageData.login_type != 3 &&
        this.principleBranchID.length > 0 &&
        this.corpBranchID.length > 0
      ) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "You can either select principle branch or corporate branch."
        });

        return;
      } else {
        this.axios
          .post(this.$loggedRole+"/schedule-feedback-report", {
            restBranchId: this.restBranchID
              ? this.restBranchID.restBranchID
              : "",
            daterange: this.daterange,
            principle_branch_id: this.principleBranchID
                ? this.principleBranchID.principleBranchID
                : "",
            corporate_branch_id: this.corpBranchID
              ? this.corpBranchID.corpBranchID
              : "",
            restaurant_employee:this.rest_employees,
            cloudkitch_staffs:this.ck_employee
          })
          .then(response => {
            this.$swal({
              icon: "success",
              title: "Schedule Feedback Report",
              text: response.data.message
            }).then(()=>{
              this.clearFilter();
                location.reload();
            });


          })
          .catch(error => {
             this.$swal({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      }
    },
    getPrincipleAndCorporates() {
      if (this.$storageData.login_type != 3) {
        this.getPrincipleBranches();
      }
      this.getCorporateBranches();
    },
    getPrincipleBranches() {
      this.axios
        .post(this.$loggedRole+"/getPrincipleBranchByPrincipleID", {
          city: this.city ? this.city.city : "",
          empTypeID: this.$storageData.profile.empTypeID,
          empID: this.$storageData.profile.principleAdminID,
          isDashboard: 1, // for all dropdown in only dashboards
          loginTypeID: this.$storageData.login_type
        })
        .then(response => {
          this.principleBranches = response.data.data;
        })
        .catch(error => {
           this.$swal({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
        });
    },
    getCorporateBranches() {
      let corporate_branch = 0;
      let corporate_id = 0;
      if (this.$storageData.profile.empTypeID == 5) {
        corporate_id = this.$storageData.profile.corporateID;
      }
      if (this.$storageData.profile.empTypeID == 6) {
        corporate_id = this.$storageData.profile.corporateID;
        corporate_branch = this.$storageData.profile.corpBranchID;
      }
      this.axios
        .post(this.$loggedRole+"/feedback-template/get-corporate-branches", {
          city: this.city ? this.city.city : "",
          empTypeID: this.$storageData.profile.empTypeID,
          empID: this.$storageData.profile.pid,
          isDashboard: 1, // for all dropdown in only dashboards
          loginTypeID: this.$storageData.login_type,
          corporate_branch: corporate_branch,
          corporate_id: corporate_id
        })
        .then(response => {
          this.corpBranches = response.data.data;
        })
        .catch(error => {
           this.$swal({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
        });
    },
    getRestaurantByPrincipleBranch() {
      if(this.principleBranchID) {
        this.axios
            .post(this.$loggedRole + "/feedback-template/principle/restaurants", {
              city: this.city ? this.city.city : "",
              principleBranchID: this.principleBranchID
                  ? this.principleBranchID.principleBranchID
                  : "",
              empTypeID: this.$storageData.profile.empTypeID,
              empID: this.$storageData.profile.principleAdminID,
              loginTypeID: this.$storageData.login_type,
              company_id: this.$storageData.profile.companyID
            })
            .then(response => {
              this.restBranchArr = response.data.data;
            })
            .catch(error => {
              this.$swal({
                icon: "error",
                title: "Oops...",
                text: error.response.data.message
              });
            });
      }
    },
    getRestaurantByCorporateBranch() {
      if (this.corpBranchID) {
        this.axios
          .post(this.$loggedRole+"/feedback-template/corporate/restaurants", {
            city: this.city ? this.city.city : "",
            corpBranchID: this.corpBranchID
              ? this.corpBranchID.corpBranchID
              : "",
            empTypeID: this.$storageData.profile.empTypeID,
            empID: this.$storageData.profile.pid,
            loginTypeID: this.$storageData.login_type,
            company_id:this.$storageData.profile.companyID
          })
          .then(response => {
            this.restBranchArr = response.data.data;
          })
          .catch(error => {
             this.$swal({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      }
    },
    readCloudkitchEmployees() {
      this.axios.get(this.$loggedRole+"/viewAllCloudKitchAdmins").then((response) => {
        this.staffs = response.data.data.map(({ empID, name }) => ({
          empID,
          name,
        }))

        });
    },
    getRestaurantEmployees(){
      if(this.restBranchID){
        this.axios
            .post(this.$loggedRole+"/get-restaurant-employees", {
              restBranchID: this.restBranchID.restBranchID,
            })
            .then(response => {
            this.employees=response.data.data
            });
      }
    
    }
  },
  middleware: "authentication"
};
</script>
<style scoped>
/** or use this class: table thead th.bTableThStyle { ... } */
textarea {
  resize: none;
}
.icon_align {
  margin-left: 15px;
}
.table .bTableThStyle {
  max-width: 12rem !important;
  text-overflow: ellipsis !important;
  background: #000;
}
.headerDiv {
  margin-bottom: 15px;
}
.setionTitle {
  border-bottom: none;
  text-align: center;
  color: #663333;
  font-size: 22px;
  margin-bottom: 10px;
}
.deliverCard {
  max-height: 95px;
  padding: 7px 8px;
  background: rgb(254, 241, 240);
}
.deliverCard figure {
  float: left !important;
  margin-right: 11px !important;
}
.restaurantCard figure {
  width: 50px;
  height: 50px;
  overflow: hidden;
  /* position: absolute; */
  margin: 0;
  /* left: 20px;
      top: 12px; */
  border: 1px solid #fff;
  border-radius: 3px;
}
.deliveryCardDiv {
  margin-top: 2px;
}
.deliverH3 {
  font-size: 14px;
  color: #663333;
  margin-bottom: 10px !important;
}
.questTitle {
  font-size: 14px;
  color: #663333;
  margin-bottom: 13px;
}
.submit-button {
  margin-top: 24px;
  margin-right: auto;
  margin-left: auto;
  display: block;
}
.submit-button a {
  width: 302px !important;
}
.btn-danger {
  line-height: 1;
}
.btn-warning {
  line-height: 1;
}
/* .modal-header{
  border-bottom:1px solid #ffffff;
} */
</style>
